<template>
  <div>
    日報一覧
    <el-form :model="form" inline>
      <el-date-picker
        v-model="form.targetMonth"
        :clearable="false"
        type="month">
      </el-date-picker>
      <el-select v-model="form.shop">
        <el-option
          v-if="groupPk"
          label="全店舗"
          :value="groupPk" />
        <el-option
          v-for="shop in shops"
          :key="shop.pk"
          :label="shop.name"
          :value="shop.pk">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        :disabled="!form.shop || isLoading"
        @click="fetchData(false)">表示</el-button>
      <el-button
        type="success"
        :disabled="!form.shop || isLoading"
        @click="fetchData(true)">再集計</el-button>
    </el-form>
    <el-form :model="narrowForm" style="margin-top: 20px;" inline>
      <el-radio-group v-model="narrowForm.calculateMinutes" size="mini">
        <el-radio-button label="all">分と時間を表示</el-radio-button>
        <el-radio-button label="hour">時間だけ表示</el-radio-button>
        <el-radio-button label="minute">分だけ表示</el-radio-button>
      </el-radio-group>
    </el-form>
    <div class="data-area" v-bind:style="dataAreaStyle" style="margin-top: 20px;">
      <el-table
        ref="table"
        :data="items"
        height="100%"
        stripe
        border
        v-loading="isLoading">
        <el-table-column
          prop="date"
          label="日付"
          width="70"
          fixed="left">
          <template slot-scope="scope">
            <div>
              {{ scope.row.date|printDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="施術情報"
          align="center">
          <el-table-column
            prop="reservationCount"
            label="予約数"
            width="70"
            align="right" />
          <el-table-column
            prop="doneCount"
            label="施術数"
            width="70"
            align="right" />
          <el-table-column
            prop="doneRate"
            label="施術率"
            width="70"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            prop="cancelCount"
            label="キャンセル"
            width="100"
            align="right" />
          <el-table-column
            prop="deleteCount"
            label="削除数"
            width="70"
            align="right" />
          <el-table-column
            prop="noShowCount"
            label="no-show"
            width="100"
            align="right" />
        </el-table-column>
        <el-table-column
          label="顧客情報"
          align="center">
          <el-table-column
            prop="firstVisitor"
            label="初来店者"
            width="80"
            align="right" />
          <el-table-column
            prop="repeatRate"
            label="リピート率"
            width="120"
            align="right"
            :formatter="rateFormatter"/>
          <el-table-column
            prop="happyTurn"
            label="ハッピーターン"
            width="120"
            align="right" />
          <el-table-column
            prop="royalTurn"
            label="ロイヤルターン"
            width="120"
            align="right" />
        </el-table-column>
        <el-table-column
          label="シフト状況"
          align="center">
          <el-table-column
            prop="staffCount"
            label="スタッフ数"
            width="100"
            align="right" />
          <el-table-column
            label="予定"
            align="center">
            <el-table-column
              label="シフト時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.shiftMinutes) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="実働時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.workMinutes) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="休憩時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.breakMinutes) }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="実績"
            align="center">
            <el-table-column
              label="シフト時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.realShiftMinutes) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="実働時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.realWorkMinutes) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="休憩時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.realBreakMinutes) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="ブロック時間"
              width="170"
              align="right">
              <template slot-scope="scope">
                <div>{{ printTime(scope.row.blockMinutes) }}</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="シャンプー台枠数"
          align="center">
          <el-table-column
            label="総数"
            width="70"
            align="right"
            prop="sinkCount" />
          <el-table-column
            label="残り"
            width="70"
            align="right"
            prop="sinkRemain" />
          <el-table-column
            label="使用率"
            width="70"
            align="right"
            :formatter="rateUsageFormatter"
            prop="sinkRemainRate" />
          <el-table-column
            label="不足"
            width="70"
            align="right"
            prop="sinkShort" />
        </el-table-column>
        <el-table-column
          label="シフト枠数"
          align="center">
          <el-table-column
            label="総数"
            width="70"
            align="right"
            prop="shiftCount" />
          <el-table-column
            label="残り"
            width="70"
            align="right"
            prop="shiftRemain" />
          <el-table-column
            label="使用率"
            width="70"
            align="right"
            :formatter="rateUsageFormatter"
            prop="shiftRemainRate" />
          <el-table-column
            label="不足"
            width="70"
            align="right"
            prop="shiftShort" />
        </el-table-column>
        <el-table-column
          label="予定稼働率"
          width="120"
          :render-header="appendTip('1つの予約を60分とした場合の予定シフトに対する稼働率')"
          align="right">
          <template slot-scope="scope">
            <div>{{ printOperationRate(scope.row, false, false)|printRate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="予定理想稼働率"
          width="140"
          :render-header="appendTip('1つの予約を40分とした場合の予定シフトに対する稼働率')"
          align="right">
          <template slot-scope="scope">
            <div>{{ printOperationRate(scope.row, false, true)|printRate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="稼働率"
          :render-header="appendTip('1つの予約を60分とした場合の実績シフトに対する稼働率')"
          width="100"
          align="right">
          <template slot-scope="scope">
            <div>{{ printOperationRate(scope.row, true, false)|printRate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="理想稼働率"
          width="120"
          :render-header="appendTip('1つの予約を40分とした場合の実績シフトに対する稼働率')"
          align="right">
          <template slot-scope="scope">
            <div>{{ printOperationRate(scope.row, true, true)|printRate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          align="right"
          width="200"
          label="最終更新日">
          <template slot-scope="scope">
            {{ scope.row.updatedAt|printDateTime }}
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="操作"
          fixed="right"
          align="center">
          <template slot-scope="scope">
            <el-tooltip content="予約ダッシュボード画面を開きます" placement="right">
              <el-button type="success" size="mini" @click="openReservation(scope.row)">
                予約一覧へ
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

import ShopType from '@/consts/ShopType'

export default {
  name: 'DailyList',
  filters: {
    printDate (val) {
      return moment(val).locale('ja').format('D (ddd)')
    },
    printRate (val) {
      let value = Math.round(val * 1000)
      if (value % 10 === 0) {
        value = (value / 10) + '.0%'
      } else {
        value = (value / 10) + '%'
      }
      return value
    },
    printDateTime (val) {
      return moment(val).locale('ja').format('YYYY/MM/DD HH:mm:ss')
    },
  },
  data () {
    return {
      form: {
        targetMonth: null,
        shop: null,
      },
      narrowForm: {
        calculateMinutes: 'all',
      },
      isLoading: false,
      dataAreaHeight: 600,
      items: [],
      groupPk: null,
      shops: [],
    }
  },
  computed: {
    dataAreaStyle () {
      return {
        'height': `${this.dataAreaHeight}px`,
      }
    },
  },
  created () {
    window.addEventListener('resize', this.setWindowHeight, false)
  },
  mounted () {
    this.form.targetMonth = moment()
    this.fetchShops()
    this.setWindowHeight()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setWindowHeight, false)
  },
  methods: {
    appendTip (tip) {
      return function (h, {column}) {
        return h('el-tooltip',
          {
            attrs: {
              effect: 'dark',
              content: tip,
              placement: 'top',
            },
          }, [h('div', [column.label])],
        )
      }
    },
    printTime (val) {
      if (!val) {
        return '-'
      }
      const hour = Math.floor(val / 60)
      let minute = val % 60
      if (String(minute).length === 1) {
        minute = '0' + minute
      }
      switch (this.narrowForm.calculateMinutes) {
        case 'all':
          return `${hour}時間${minute}分 (${val}分)`
        case 'hour':
          return `${hour}時間${minute}分`
        case 'minute':
          return `${val}分`
      }
    },
    printOperationRate (row, real, ideal) {
      let working
      if (real) {
        working = row.realWorkMinutes
      } else {
        working = row.workMinutes
      }
      const actual = row.doneCount * (ideal ? 40 : 60)
      return working ? actual / working : 0
    },
    fetchData (recalculate = false) {
      if (!this.form.shop) {
        return
      }
      let year = moment(this.form.targetMonth).year()
      let month = moment(this.form.targetMonth).month() + 1
      this.isLoading = true
      this.$request.analytics.dailyList(year, month, this.form.shop, recalculate).then(res => {
        this.items = res.body
      }).finally(() => {
        this.isLoading = false
      })
    },
    fetchShops () {
      this.$request.shops.list().then(res => {
        this.shops = res.body.results.filter(obj => obj.shopType === ShopType.SHOP)
        this.groupPk = res.body.results.find(obj => obj.shopType === ShopType.GROUP).pk
      })
    },
    rateFormatter (row, col, val) {
      return (Math.round(val * 1000) / 10) + '%'
    },
    rateUsageFormatter (row, col, val) {
      val = 1 - val
      return (Math.round(val * 1000) / 10) + '%'
    },
    getSummaries ({columns, data}) {
      let sums = []
      columns.forEach((column, index) => {
        const key = column.property
        if (key === 'date' || key === 'updatedAt' || key.endsWith('Rate')) {
          if (key === 'date') {
            sums.push('合計')
          } else {
            sums.push('')
          }
          return true
        }
        let sum = 0
        data.forEach(row => {
          sum += row[key]
        })
        sums.push(sum)
      })
      return sums
    },
    setWindowHeight: _.debounce(function () {
      this.dataAreaHeight = window.innerHeight - 250
    }, 300),
    openReservation (row) {
      const tmp = moment(row.date).locale('ja').format('YYYY/MM/DD')
      const url = `${process.env.RESERVATION_DASHBOARD}${row.shop}/${tmp}`
      window.open(url)
    },
  },
}
</script>

<style scoped>
.data-area {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics/DailyList.vue